import { ar } from "@/assets/locales/ar";
import { en } from "@/assets/locales/en";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";


export type SupportedLanguage = "en" | "ar";

const getLanguageFromURL = (): SupportedLanguage => {
  if (typeof window === "undefined") {
    return "ar";
  }

  const urlParams = new URLSearchParams(window.location.search);
  const langParam = urlParams.get("lang") || urlParams.get("language");

  if (langParam && (langParam === "en" || langParam === "ar")) {
    return langParam as SupportedLanguage;
  }

  return "ar";
};

const resources = {
  en: {
    translation: en
  },
  ar: {
    translation: ar
  }
};

i18n.use(initReactI18next).init({
  resources,
  lng: getLanguageFromURL(),
  fallbackLng: "en",

  interpolation: {
    escapeValue: false
  },

  react: {
    useSuspense: false
  }
});

export default i18n;
